import { render } from "./a-b-testing.vue?vue&type=template&id=a98c7382&scoped=true"
import script from "./a-b-testing.vue?vue&type=script&lang=js"
export * from "./a-b-testing.vue?vue&type=script&lang=js"

import "./a-b-testing.vue?vue&type=style&index=0&id=a98c7382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98c7382"]])

export default __exports__